import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { ConnectIntegrationsRoutingModule } from './connect-integrations-routing.module';
import { ConnectIntegrationsComponent } from './connect-integrations.component';
import { SharedIntegrationsModule } from '../../shared/integrations/shared-integrations.module';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        SharedModule,
        ConnectIntegrationsRoutingModule,
        SharedIntegrationsModule
    ],
    declarations: [ConnectIntegrationsComponent],
    exports: [ConnectIntegrationsComponent],
    providers: []
})
export class ConnectIntegrationsModule {}
